/* eslint-disable jsx-a11y/anchor-has-content */

import "../styles/footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div>
        <p>
          Made with 💛{" "}
          <a href="https://github.com/chintan0513">Chintan Tripathi</a> © 2025.
        </p>
      </div>
    </div>
  );
};

export default Footer;
